<div class="list-group-item pt-3 pb-2 list-group-item-action clearfix" [class.new]="!notification.readDateTime">
  <div class="notification d-flex align-items-center">
    <span class="avatar bg-transparent">
      <app-avatar
        avatarSize="avatar-sm"
        avatarColor="avatar-teal"
        [avatarUrl]="notification.createdByUserId | avatarById | async"
        [avatarInitial]="notification.createdByUserId | userById: 'initials' | async" />
    </span>
    <span class="notification-caption ml-1 cursor-pointer" (click)="openNotification(notification, false)">
      <span class="notification-msg" [innerHtml]="notification.message"></span>
      <span class="notification-time"> {{ notification.timeToShow }} </span>
      @if (notification.assignmentFriendlyNumber) {
        <span class="notification-time">•</span>
      }
      @if (notification.assignmentFriendlyNumber) {
        <span class="notification-time"
          >{{ '$number_abbreviation_label$' | translate }} {{ notification.assignmentFriendlyNumber }}</span
        >
      }
    </span>
    <span class="cursor-pointer notification-status" (click)="markNotification(notification)"></span>
  </div>
</div>
